import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { Select } from "antd";
import numeral from "numeral";
import uuidv4 from "uuid/v4";
import "../style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FirstRegimeField from "./articleRow/regimeVal";
import ExtraRegimeField from "./articleRow/extraRegimeVal";
import DestinationFields from "./articleRow/destination";
import { useSelector } from "react-redux";

const Option = Select.Option;

const SplitArticleRow = ({
  currentArticle,
  currentConto,
  contiNew,
  articlesList,
  setArticlesList,
  changeArticle,
  isDebit,
  index,
  isMonoRegime,
  totalAmount,
  setTotalAmount,
  isDocument,
  setModifiedDetail
}) => {
  const accounts = useSelector(state => state.precog.detailAccounts.data?.accountingLinesByCodeApiResList);

  const [regimeVal, setRegimeVal] = useState("");
  const [regimeFind, setRegimeFind] = useState("");
  const [articleAccount, setArticleAccount] = useState("");
  const [accountsOptionsList, setAccountsOptionsList] = useState([]);

  useEffect(() => {
    if (!currentArticle?.regimeId) return;
    setRegimeVal(currentArticle.regimeId);
  }, [currentArticle?.regimeId]);
  
  useEffect(() => {
    if (!currentConto?.uuid) return;
    setArticleAccount(currentConto.uuid);
  }, [currentConto?.uuid]);

  useEffect(() => {
    if (!accounts) return;
    let options = [];
    accounts.map(el => el?.isPosting ? options.push(<Option
      key={"articles-accordion-select_" + uuidv4()}
      value={el?.uuid}
    >
      {el?.accountDesc}
    </Option>) : null);
    setAccountsOptionsList(options);
  }, [accounts]);

  const addArticle = () => {
    const newItem = {
      rowKey: uuidv4(),
      accountCode: currentConto?.accountCode,
      accountDesc: currentConto?.accountDesc,
      credit: 0,
      debit: 0,
      articleDesc: currentArticle?.articleDesc,
      endPeriodDate: currentConto?.endPeriodDate,
      startPeriodDate: currentConto?.startPeriodDate,
      regimeId: articlesList[0]?.regimeId,
      regimeExtraField: articlesList[0]?.regimeExtraField,
      vatDestinationId: articlesList[0]?.vatDestinationId,
      exemptionNatureId: articlesList[0]?.exemptionNatureId,
      exemptionNature: articlesList[0]?.exemptionNature,
      vatRate: articlesList[0]?.vatRate
    };
    let current = [...articlesList];
    current.push(newItem);
    setArticlesList(current);
  };

  const removeArticle = () => {
    const filterListRemoved = articlesList.filter(el => el.rowKey !== currentArticle.rowKey);
    setArticlesList(filterListRemoved);
    calculateFirstLineTotal(true);
  };

  const onArticleChange = (kind, value) => {
    if (index === 0) {
      changeArticle({ uuid: currentArticle?.uuid, type: kind, value: value }, index);
    } else {
      let newList = [];
      articlesList.map((el, idx) => {
        if (idx === index) {
          newList.push({...el, [kind]: value});
        } else {
          newList.push(el);
        }
      });
      setArticlesList(newList);
    }
  };

  const calculateFirstLineTotal = (onRemove) => {
    let total = isDebit ? articlesList[0].debit : articlesList[0].credit;
    articlesList.map((el, idx) => {
      if (idx !== 0) {
        if (onRemove) {
          if (isDebit) {
            total = currentArticle.rowKey !== el.rowKey ? total - el.debit : total;
          } else {
            total = currentArticle.rowKey !== el.rowKey ? total - el.credit : total;
          }
        } else {
          total = isDebit ? total - el.debit : total - el.credit;
        }
      } else return;
    });
    setTotalAmount(total);
  };

  return (
    <div data-testid="SplitArticleRow" className="split-article-row">
      <div>
        <div className="split-article-input-label">Importo</div>
        <NumberFormat
          className="split-article-input"
          style={{width: 100, border: "1px solid #c9d9e8", cursor: index === 0 && articlesList.length > 1 ? "not-allowed" : "initial"}}
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          placeholder="Importo"
          suffix={" €"}
          disabled={index === 0 && articlesList.length > 1}
          value={
            index === 0 ? numeral(totalAmount).format("0,0.00") :
              currentArticle?.debit !== 0
                ? numeral(Math.abs(currentArticle?.debit)).format("0,0.00")
                : currentArticle.credit !== 0
                  ? numeral(Math.abs(currentArticle?.credit)).format("0,0.00")
                  : undefined
          }
          onBlur={e => calculateFirstLineTotal(false)}
          onChange={e => {
            const value = e.target.value ? parseFloat(e.target.value.replace(".", "").replace(",", ".")) : 0;
            if (index === 0) {
              setTotalAmount(value);
            }
            isDebit ? currentArticle.debit = value : currentArticle.credit = value;
            isDebit ? onArticleChange("debit", value) : onArticleChange("credit", value);
          }}
        />
      </div>
      <div>
        <div className="split-article-input-label">Regime IVA</div>
        <FirstRegimeField
          isAccountRow={false}
          article={currentArticle}
          regimeVal={regimeVal}
          setRegimeVal={setRegimeVal}
          onArticleChange={onArticleChange}
          regimeFind={regimeFind}
          isMonoRegime={isMonoRegime}
        />
      </div>
      <div>
        <div className="split-article-input-label">{regimeFind?.field}</div>
        <ExtraRegimeField
          isAccountRow={false}
          article={currentArticle}
          regimeVal={regimeVal}
          setRegimeVal={setRegimeVal}
          onArticleChange={onArticleChange}
          regimeFind={regimeFind}
          isMonoRegime={isMonoRegime}
          setRegimeFind={setRegimeFind}
        />
      </div>
      <div>
        <div className="split-article-input-label">Conto contabile</div>
        <Select
          showSearch
          optionFilterProp="children"
          getPopupContainer={trigger => trigger.parentNode}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onSelect={value => {
            currentArticle.accountUuid = value;
            const filteredConto = contiNew.filter(el => el.uuid === value);
            if (index === 0 ){
              setModifiedDetail({ accountingLine: [currentArticle.uuid], modifiedData: { accountCode: filteredConto[0]?.accountCode, destinationGroupId: value } });
            }            
            setArticleAccount(value);            
            currentArticle.accountDesc = filteredConto[0]?.accountDesc;
            currentArticle.accountCode = filteredConto[0]?.accountCode;
          }}
          className="split-article-input"
          value={articleAccount}
          placeholder="Sel. conto contabile"
          style={{ width: 210 }}
          dropdownClassName="split-article-input-accordion"
        >
          {accountsOptionsList}
        </Select>
      </div>
      <div>
        <div className="split-article-input-label">Destinazione</div>
        <DestinationFields article={currentArticle} onArticleChange={onArticleChange}/>
      </div>
      <div className="split-article-icons">
        <FontAwesomeIcon icon={["far", "trash-alt"]} onClick={() => index !== 0 ? removeArticle() : null} style={index === 0 ? {color: "#c9d9e8", cursor: "not-allowed"} : {}}/>
        <FontAwesomeIcon icon={["far", "plus-circle"]} onClick={() => addArticle()}/>
      </div>
    </div>
  );
};

export default SplitArticleRow; 
